import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './../styles/car-cover-images.css';
import { isMobile } from '../constants/device';
import { PRODUCTS_MAP } from '../constants/product';
import { API_URL } from '../constants/urls';
import { Box, CircularProgress } from '@mui/material';

function CarCoverImages({ showImageInfo = true, selectedColor, selectedSecondaryColor, imageHandle }) {
  const [imageUrl, setImageUrl] = useState("");

  const loadImages = async (data) => {
    if (isMobile) {
      setImageUrl(data[0]);
    } else {
      const images = data.reverse();

      for (const imageUrl of images) {
        setImageUrl(imageUrl);
        await new Promise(resolve => setTimeout(resolve, 250));
      }
    }
  }

  const getImages = async () => {
    let params = {
      product: imageHandle,
      color: selectedColor.color
    }

    if (window?.conspire_product?.handle === PRODUCTS_MAP['flannelguard-supreme']?.handle) {
      params.piping = selectedSecondaryColor.color;
    }

    const { data } = await axios.get(`${API_URL}/api/images/product_images/`, {
      params
    });

    loadImages(data);
  }

  useEffect(() => {
    getImages();
  }, [selectedColor, selectedSecondaryColor]);

  const imageEl = !!imageUrl ? (
    <img src={imageUrl} alt="Car Cover Image" />
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '30px' }}>
      <CircularProgress sx={{ color: '#00f' }} />
    </Box>
  )

  return (
    <section className="car-cover-images-container">
      <div className="car-cover-image-container">
        {imageEl}
      </div>
      {showImageInfo && (
        <p className="car-cover-images-info">REPRESENTATIVE IMAGE SHOWN</p>
      )}
    </section>
  )
}

export default CarCoverImages
